<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        Edit Well Production Category
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>
<hr class="my-0">

<mat-dialog-content>
    <table class="table editTable">
        <tr>
            <td class="w-1/4 pb-6">
                Field
            </td>
            <td class="w-1/4">
                <mat-form-field class="w-full">
                    <input matInput placeholder="" [(ngModel)]="wellProdDetailsBody.fieldName" disabled>
                </mat-form-field>
            </td>
            <td class="w-1/4 pb-6">
                Last Updated By
            </td>
            <td class="w-1/4">
                <mat-form-field class="w-full">
                    <input matInput placeholder="" [(ngModel)]="wellProdDetailsBody.lastUpdatedBy" disabled>
                </mat-form-field>
            </td>
        </tr>
        <tr>
            <td class="pb-6">
                Platform
            </td>
            <td>
                <mat-form-field class="w-full">
                    <input matInput placeholder="" [(ngModel)]="wellProdDetailsBody.platformName" disabled>
                </mat-form-field>
            </td>
            <td class="pb-6">
                Last Updated Date
            </td>
            <td>
                <mat-form-field class="w-full">
                    <input matInput placeholder="" [(ngModel)]="wellProdDetailsBody.lastUpdatedDate" disabled>
                </mat-form-field>
            </td>
        </tr>
        <tr>
            <td class="pb-6">
                String
            </td>
            <td>
                <mat-form-field class="w-full">
                    <input matInput [(ngModel)]="wellProdDetailsBody.wellStringName" disabled>
                </mat-form-field>
            </td>
            <td class="pb-6">
                Production Status
            </td>
            <td>
                <mat-form-field class="w-full">
                    <mat-select [(ngModel)]="wellProdDetailsBody.prodStatus"
                        [disabled]="tempProdStatus == 'Plug And Abandon'">
                        <mat-option *ngFor="let status of productionStatusList" [value]="status">
                            {{ status }} </mat-option>
                    </mat-select>
                </mat-form-field>
            </td>
        </tr>
        <tr>
            <td class="pb-6">
                String Indicator
            </td>

            <td>
                <mat-form-field class="w-full">
                    <input matInput placeholder="" [(ngModel)]="wellProdDetailsBody.stringIndicatorShortName" disabled>
                </mat-form-field>
            </td>
        </tr>

        <tr>
            <td class="pb-6">
                Well Type
            </td>
            <td>
                <mat-form-field class="w-full">
                    <mat-select [(ngModel)]="wellProdDetailsBody.wellType">
                        <mat-option *ngFor="let wellType of wellTypeList" [value]="wellType">
                            {{ wellType }} </mat-option>
                    </mat-select>
                </mat-form-field>
            </td>
        </tr>

        <tr>
            <td class="pb-6">
                Flow Category
            </td>
            <td>
                <mat-form-field class="w-full">
                    <mat-select [(ngModel)]="wellProdDetailsBody.flowCategory"
                        [disabled]="!wellProdDetailsBody.wellType?.includes('Oil')">
                        <ng-container *ngIf="!wellProdDetailsBody.wellType?.includes('Oil')">
                            <mat-option [value]="''"></mat-option>
                        </ng-container>

                        <ng-container *ngIf="wellProdDetailsBody.wellType?.includes('Oil')">
                            <mat-option *ngFor="let wellType of flowCategoryList" [value]="wellType">
                                {{ wellType }} </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </td>
        </tr>

    </table>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-outline btn-error mx-4" mat-dialog-close>Cancel</button>
    <button class="btn btn-primary" [disabled]="isProductionStatusDetailsChange()"
        (click)="updateWellProdStatus()">Update</button>
</mat-dialog-actions>

<ng-template #closedIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
</ng-template>